import React, { useMemo } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import WebLayout from "../components/WebLayout";
import PostList from "../components/PostList";

const GET_HYPNOTISTS = gql`
  query GetHypnotists($latest: Boolean) {
    hypnotists(latest: $latest) {
      id
      picture {
        filename
        mimetype
        encoding
        location
      }
      email
      address
      line
      facebook
      name
      content
      # "緯度（由 address 於伺服器端 geocode 而來，查不到時為 null）"
      latitude
      # "經度（由 address 於伺服器端 geocode 而來，查不到時為 null）"
      longitude
    }
  }
`;

export default function Hypnotist() {
  const { data, loading } = useQuery(GET_HYPNOTISTS, {
    fetchPolicy: "network-only",
    variables: { latest: true },
  });
  // 直接使用 gql 回傳的經緯度（伺服器端已完成 geocode），不再於前端呼叫 Geocode。
  // 經緯度為 null（伺服器查不到）者略過，避免產生無效座標的地圖標記。
  const googleMapLocation = useMemo(() => {
    if (!data || !data.hypnotists) return [];
    return data.hypnotists
      .filter((item) => item.latitude != null && item.longitude != null)
      .map((item) => ({
        lat: item.latitude,
        lng: item.longitude,
        title: item.name,
        id: item.id,
      }));
  }, [data]);
  return (
    <WebLayout data={googleMapLocation}>
      {loading ? (
        <Grid container justify="center">
          <CircularProgress color="secondary" />
        </Grid>
      ) : (
        <PostList data={data ? data.hypnotists : undefined} />
      )}
    </WebLayout>
  );
}
